import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { ConfirmationServiceService } from 'src/app/Services/confirmation-service.service';

@Component({
  selector: 'app-confirmation-dialoge',
  templateUrl: './confirmation-dialoge.component.html',
  styleUrls: ['./confirmation-dialoge.component.css']
})
export class ConfirmationDialogeComponent {
 message: string = ''
 imageUrl?: string;
  private confirmCallback: (() => void) | null = null
  private cancelCallback: (() => void) | null = null
  isVisible: boolean = false 

  constructor(private confirmDialogService: ConfirmationServiceService) {}
ngOnInit() {
  this.confirmDialogService.confirmation$.subscribe(({ message, callback, imageUrl, cancelCallback }) => {

    this.message = message;
    this.confirmCallback = callback;
    this.cancelCallback = cancelCallback || null;
    this.isVisible = true;
    this.imageUrl = imageUrl;
  });
}

  private closeCanvasSource = new Subject<void>();
  closeCanvas$ = this.closeCanvasSource.asObservable();
  onConfirm() {
    if (this.confirmCallback) {
      this.confirmCallback()
    }
    this.closeDialog()
  }

  onCancel() {
    if (this.cancelCallback) {
      this.cancelCallback();
    }
    this.closeDialog();
  }

  closeDialog() {
    this.isVisible = false 
  }
  

  triggerCloseCanvas() {
    this.closeCanvasSource.next();
  }
}
